module.exports = __webpack_public_path__ + "img/Loose Pin.24077d85.png";